export const USER_TYPE = "USER_TYPE";

export function setUserType(userType, isType) {
  return {
    type: USER_TYPE,
    userType,
    isType
  };
}
